import script from "./ArchiveDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveDevices.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveDevices.vue?vue&type=style&index=0&id=71843b6d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71843b6d"]])

export default __exports__